import React from "react";

const Footer = () => {
  return (
    <div className="container mx-auto p-4 flex flex-wrap gap-2 items-center justify-between">
      <div className="text-[0.9rem] text-blue">
        &#169; 2023 All rights deserved.
      </div>
    </div>
  );
};

export default Footer;
